;"use strict";


if (typeof bc_js == 'undefined') {
    bc_js = {};
};

;bc_js.stickyHeader = (function ($) {

    var $sticky;
    var $sticky_top;
    var $body;
    var $sticky_class;
    var $left;
    var $width;

    let navContainer = $('#hp_navigation-container');
    let navHeight = navContainer.outerHeight();
    let sticky = navContainer.offset().top;
    let bannerLoaded = false;

    function init() {
        $(window).scroll(toggleDynamicShadow);
        $(window).scroll(fixOnScroll);
    }

    function fixOnScroll() {
        let bannerContainer = $('.billboard-container');
        let hpMain = $('main');

        if (getVw() > 1024) {
            if (bannerContainer.outerHeight() > 20 && !bannerLoaded) {
                sticky = bannerContainer.outerHeight();
                bannerLoaded = true;
            }

            if ($(window).scrollTop() > sticky && !navContainer.hasClass('hp_sticky')) {
                navContainer.addClass('hp_sticky');
                hpMain.css({'padding-top': navHeight});
            } else if ($(window).scrollTop() <= sticky && navContainer.hasClass('hp_sticky')) {
                navContainer.removeClass('hp_sticky');
                hpMain.css({'padding-top': 0});
            }
        }
    }

    function toggleDynamicShadow() {
        let navContainer = $('#hp_navigation-container');
        let top = 25;

        if (hasSearchForm()) {
            navContainer.addClass('has-search');
        }

        // Trigger dynamic shadow at a higher position on mobile devices:
        if (getVw() < 1024) {
            top = 5;
        }

        // only apply shadow
        // 1. on mobile when scrolled
        // 2. on desktop when navContainer is fixed at top (and scrolled)
        if ($(document).scrollTop() >= top && (navContainer.css('position') === 'fixed' || getVw() < 1024)) {
            navContainer.addClass('shadowed');
        } else {
            navContainer.removeClass('shadowed');
        }
    }

    function getVw() {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0); // Cross Browser Viewport Width;
    }

    function hasSearchForm() {
        let search_form = $('#hp_search-form');
        return (search_form && search_form.css('display') !== 'none' && search_form.outerHeight() > 10);
    }

    return {
        init: init
    }
})(jQuery);

$(document).ready(function () {
    bc_js.stickyHeader.init();
});

;bc_js.toggle_body_scroll_lock = (function ($) {

    let saved_position = undefined;
    let $doc = $(document);
    let $html = $('html');
    let $body  = $('body');
    let initial_scroll_behavior;

    /** @param {Boolean} lock */
    function toggle_body_scroll_lock(lock) {

        if (lock) {
            // save current scroll position
            saved_position = $doc.scrollTop();
            initial_scroll_behavior = $html.css("scroll-behavior");
            $('html, body').css("scroll-behavior", "auto");

            // set extra css
            $body.css({
                top: - (saved_position),
            });
            $html.css({
                height: 'auto',
            });
        }

        // remove classes
        $body.toggleClass('hp_no-scroll', lock);

        if (!lock) {

            $body.css({
                top: '',
            });
            $html.css({
                height: '100%',
            });

            let $mobile_navigation = $('#hp_mobile-main-navigation');
            let nav_visible = $mobile_navigation.is(":visible");

            // scroll to position
            if (saved_position !== undefined) {
                $(document).scrollTop(saved_position);
                $('html, body').css("scroll-behavior", initial_scroll_behavior);
            }
        }
    }

    return {
        toggle_body_scroll_lock: toggle_body_scroll_lock
    }

})(jQuery);

;bc_js.mobile_navigation = (function ($) {
    let $body = $('body');
    let $mobile_navigation = $('#hp_mobile-main-navigation');
    let toggle_body_scroll_lock = bc_js.toggle_body_scroll_lock.toggle_body_scroll_lock;

    function show_mobile_navigation(){
        let nav_visible = $mobile_navigation.is(":visible");

        if (!nav_visible) {
            $body.addClass('open-overlay');
            toggle_body_scroll_lock(true);
            $mobile_navigation.show();
            $mobile_navigation.css({'background-color': 'rgba(0, 0, 0, 0.5)'});
        }
    }

    function hide_mobile_navigation(){
        let nav_visible = $mobile_navigation.is(":visible");

        if (nav_visible) {
            $body.removeClass('open-overlay');

            // only release body scroll lock, if no other overlay is open and if nav is open
            if ($('.open-overlay').length === 0) {
                toggle_body_scroll_lock(false);
            }
            $mobile_navigation.css({'background-color': ''});
            $mobile_navigation.hide();
        }
    }

    function toggle_mobile_navigation(){
        if ($body.hasClass('has-mobile-navigation')){
            hide_mobile_navigation();
        } else {
            show_mobile_navigation();
        }
    }

    function init() {
        $('.hp_toggle-mobile-navigation').on('click', toggle_mobile_navigation);

        $(".hp_mobile-navigation-wrapper").click(function(e){
            if(e.target !== this) return;
            hide_mobile_navigation()
        });


        // don't open menu, when swipe is on horizontally scrollable element
        document.addEventListener('touchstart', function (e) {
            e.stopPropagation();
        }
        , {passive: true});
    }

    return {
        init: init
    }
})(jQuery);

jQuery(document).ready(function () {
    bc_js.mobile_navigation.init();
});
